<template>
	<AppHeaderDropdown right no-caret>
		<template slot="header">
			<i class="icon-bell"></i>
			<b-badge pill variant="danger" v-if="pendingAuthTicketsCount > 0">{{pendingAuthTicketsCount}}</b-badge>
		</template>
		<template slot="dropdown">
			<b-dropdown-header tag="div" class="text-center"><strong>Tickets Pendientes de Autorización</strong>
			</b-dropdown-header>
			<div class="w-100 text-center p-1" v-if="loading">
				<b-spinner small variant="info" label="Small Spinner"></b-spinner>
			</div>
			<div class="dropdown-item" v-for="ticket in pendingAuthTicketsList">
				<div class="mb-1" :id="ticket.Number">
					<small class="text-uppercase"><b># Ticket: {{ticket.Number}}</b></small>
					<b-tooltip :target="ticket.Number" triggers="hover">
						{{ticket.Description}}
					</b-tooltip>
					<!--<small class="text-muted d-block">{{ticket.Description|subStr}}</small>-->
					<small class="text-muted d-block"># Cuenta: {{ticket.Account.Number}}</small>
					<small class="text-muted d-block">Alias: {{ticket.Account.Alias}}</small>
					<small class="text-muted d-block">F. Creación: {{ticket.CreatedOn|dateFormatFull}}</small>
				</div>
				<b-button class="btn-block btn-sm" variant="success"
						  @click="authTicket(ticket.Id, ticket.Account.Id)">
					<i class="fa fa-check text-white" aria-hidden="true"></i> Autorizar
				</b-button>
			</div>
			<b-dropdown-item v-if="pendingAuthTicketsCount > 5">
				<div class="text-uppercase mb-1 w-100 text-center">
					<router-link :to="{name: 'PendingAuthTicketList'}"><small class="text-dark"><b>Ver todos los
						tickets</b></small></router-link>
				</div>
			</b-dropdown-item>
			<b-dropdown-item v-if="pendingAuthTicketsCount <= 0">
				<div class="text-uppercase mb-1 w-100 text-center">
					<small><b>No hay tickets pendientes</b></small>
				</div>
			</b-dropdown-item>
		</template>
	</AppHeaderDropdown>
</template>

<script>
	import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue';
	import {mapState} from "vuex";

	export default {
		name: 'DefaultHeaderDropdownAccnt',
		components: {
			AppHeaderDropdown
		},
		mounted() {
			this.getPendingAuthTickets();
		},
		data: () => {
			return {
				loading: false
			}
		},
		methods: {
			getPendingAuthTickets() {
				this.loading = true;
				this.$store.dispatch('getPendingAuthTickets')
					.finally(() => {
						this.loading = false;
					})
			},
			authTicket(ticketId, accountId) {
				this.loading = true;
				this.$store.dispatch('quickAuthTicket', {TicketId: ticketId, AccountId: accountId})
					.then(() => {
						this.getPendingAuthTickets();
					})
					.catch((err) => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					})
			}
		},
		computed: {
			...mapState({
				user: state => JSON.parse(state.user),
				pendingAuthTickets: state => state.pendingAuthTickets,
			}),
			pendingAuthTicketsCount: function () {
				return this.pendingAuthTickets.length;
			},
			pendingAuthTicketsList: function () {
				return this.$store.getters.pendingAuthTicketsList;
			}
		}
	}
</script>
